import { useState } from 'react';
import { useNavigate } from "react-router-dom";

import { GetPhotoPerfil } from 'services/home/getPhotoPerfil';
import { GetCustomerCard } from 'services/home/getCustomerCard';
import { PostSavePhoto } from 'services/home/postSavePhoto';
import { GetPlatformRemoval } from 'services/home/getPlatformRemoval';
import { GetUrlAdvantagesClub } from 'services/home/getUrlAdvantagesClub';
import { GetInitialServicesHome } from 'services/home/getInitialServicesHome';
import { GetFitClientScheduling } from 'services/scheduling/getFitClientScheduling';
import { PostGetVirtualFencesHistory } from 'services/home/postGetVirtualFencesHistory';

import { ParamsCustomerCars, ParamsPersonalCardByPlatform, ParamsBodySavePhoto, ParamsDataGetPlatformRemoval, ParamsBodyGetVirtualFencesHistory, ParamsDataGetVirtualFencesHistory, ParamsDataGetFitClientScheduling } from 'utils/typeServices';

const useHome = () => {
    const navigate = useNavigate();
    const [blockClick, setBlockClick] = useState(false);
    const [isViewModal, setIsViewModal] = useState(false);
    const [photoCustomer, setPhotoCustomer] = useState<any>();
    const [selectedCar, setSelectedCar] = useState<ParamsCustomerCars>();
    const [customerCars, setCustomerCars] = useState<Array<ParamsCustomerCars>>([]);
    const [customerCard, setCustomerCard] = useState<ParamsPersonalCardByPlatform>();
    const [dataGetPlatformRemoval, setDataGetPlatformRemoval] = useState<Array<ParamsDataGetPlatformRemoval>>();
    const [dataGetVirtualFencesHistory, setDataGetVirtualFencesHistory] = useState<ParamsDataGetVirtualFencesHistory>();
    const [dataFitClientScheduling, setDataFitClientScheduling] = useState<Array<ParamsDataGetFitClientScheduling>>();

    const handleClearHome = () => {
        setBlockClick(false);
        setIsViewModal(false);
        setPhotoCustomer(undefined);
        setSelectedCar(undefined);
        setCustomerCars([]);
        setCustomerCard(undefined);
        setDataGetPlatformRemoval(undefined);
        setDataFitClientScheduling(undefined);
        setDataGetVirtualFencesHistory(undefined);
    }

    const handleClearSchedulingHome = () => {
        setDataGetPlatformRemoval(undefined);
        setDataFitClientScheduling(undefined);
    }

    const handleSelectedCard = async (token: string, NR_PLATAFORMA: number) => {
        const { data: customerCardAux } = await GetCustomerCard({ token, platformId: NR_PLATAFORMA });

        customerCardAux && setCustomerCard(customerCardAux);
    }

    const handleSelectedCar = (data: ParamsCustomerCars) => {
        setSelectedCar(data);
        const token = localStorage.getItem('token');
        token && handleSelectedCard(token, data.NR_PLATAFORMA);
    }

    const handleIsViewModal = () => {
        setIsViewModal(true);
    }

    const handleGetInitialServices = async ({ token, isWebView = false }: { token: string, isWebView?: boolean }) => {
        const { data } = await GetInitialServicesHome({ token });
        const { data: dataPerfilPhoto } = await GetPhotoPerfil({ token });
        const { data: dataPlatformRemoval } = await GetPlatformRemoval({ token });
        const { data: dataFitClientScheduling } = await GetFitClientScheduling();

        if (dataPerfilPhoto) {
            setPhotoCustomer(dataPerfilPhoto);
        }

        if (dataPlatformRemoval && dataPlatformRemoval.length > 0) {
            setDataGetPlatformRemoval(dataPlatformRemoval);
        } else {
            setDataGetPlatformRemoval([]);
        }

        if (dataFitClientScheduling && dataFitClientScheduling.length > 0) {
            setDataFitClientScheduling(dataFitClientScheduling);
        } else {
            setDataFitClientScheduling([]);
        }

        if (data) {
            const dataCar = data?.ServicosPlataformas.map(({ MARCA, CD_PESSOA_PARCEIRO, COMODATO, FL_CONSULTA_PLACA, TECNOLOGIA, POCSAG, NR_TIPO_PRODUTO, CD_PRODUTO, CD_SEGMENTO, CD_PESSOA_BENEFICIARIO, CD_PEDIDO, CD_PESSOA, NR_CNPJ_CPF, EMAIL, PRODUTO, COR, PLACA, ATIVO, CHASSI, MODELO, MODELO_ANO, NM_MODELO_BASICO, NR_PORCENTAGEM_INDENIZACAO, NR_PLATAFORMA, NOME_CLIENTE_ABREVIADO, NOME_CLIENTE, CODIGO_SEGURADORA, CD_PESSOA_VENDEDOR, CD_PESSOA_PARCEIRO_ESTABELECIMENTO, CD_MODELO, CD_TIPO_PLATAFORMA, FL_ICS_LIGHT, FL_ITURAN_ONE, FL_ELEGIVEL_PLATINUM }: any) => {
                return {
                    MARCA, CD_PESSOA_PARCEIRO, COMODATO, FL_CONSULTA_PLACA, TECNOLOGIA, POCSAG, NR_TIPO_PRODUTO, CD_PRODUTO, CD_SEGMENTO, CD_PESSOA_BENEFICIARIO, CD_PEDIDO, CD_PESSOA, NR_CNPJ_CPF, EMAIL, PRODUTO, COR, PLACA: PLACA || '', ATIVO, CHASSI: CHASSI || '', MODELO, MODELO_ANO, NM_MODELO_BASICO, NR_PORCENTAGEM_INDENIZACAO, NR_PLATAFORMA, NOME_CLIENTE_ABREVIADO, NOME_CLIENTE, CODIGO_SEGURADORA, CD_PESSOA_VENDEDOR, CD_PESSOA_PARCEIRO_ESTABELECIMENTO, CD_MODELO, CD_TIPO_PLATAFORMA, FL_ICS_LIGHT, FL_ITURAN_ONE, FL_ELEGIVEL_PLATINUM
                }
            });

            setCustomerCars(dataCar);
            setSelectedCar(dataCar[0]);

            if (!customerCard) {
                token && handleSelectedCard(token, data.ServicosPlataformas[0].NR_PLATAFORMA);
            }
        } else if (dataPlatformRemoval) {
            setBlockClick(true);
        } else {
            isWebView && navigate('/');
        }
    }

    const handlePostSavePhoto = async ({ token, body }: { token: string, body: ParamsBodySavePhoto }) => {
        const { data } = await PostSavePhoto({ token, body });

        if (data) {
            const { data: dataPerfilPhoto } = await GetPhotoPerfil({ token });

            if (dataPerfilPhoto) {
                setPhotoCustomer(dataPerfilPhoto);
            }
        }
    }

    const handlePostGetVirtualFencesHistory = async ({ body }: { body: ParamsBodyGetVirtualFencesHistory }) => {
        setDataGetVirtualFencesHistory(undefined);
        const { data } = await PostGetVirtualFencesHistory({ body });

        (data && data.length > 0) && setDataGetVirtualFencesHistory(data[0]);
    }

    const handleGetUrlAdvantagesClub = async () => {
        const data = await GetUrlAdvantagesClub();

        if (data.data) {
            window.open(data.data);
        }
    }

    return { selectedCar, customerCars, customerCard, photoCustomer, dataGetPlatformRemoval, isViewModal, blockClick, dataGetVirtualFencesHistory, dataFitClientScheduling, handleGetInitialServices, handleSelectedCar, handlePostSavePhoto, handleClearHome, handleIsViewModal, handlePostGetVirtualFencesHistory, handleGetUrlAdvantagesClub, handleClearSchedulingHome };
}

export default useHome;